import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'icon-text',
  templateUrl: './icon-text.component.html',
  styleUrls: ['./icon-text.component.scss']
})
export class IconTextComponent {

  private _clickIcon = new EventEmitter<MouseEvent>();

  @Input()
  public icon: string;

  @Input()
  public size: number = 20;

  @Output()
  public get clickIcon() {
    return this._clickIcon;
  }
}
